module.exports = "<!--The whole content below can be removed with the new code.-->\n\n<router-outlet></router-outlet>\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main